export default "Transaction successfully processed.\r\n"